import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react';
import React, { useEffect, useState } from 'react'
import { Button, Typography } from '@pw-tech/omni-ui';
import { GuideModalData } from '@utils/constants';
import { XMarkIcon } from '@heroicons/react/24/solid'
import User31 from "@assets/images/sales/user3-1.webp";
import User11 from "@assets/images/sales/user11.svg";



const GuideModal = ({ isOpen, onClose }: { isOpen: boolean, onClose: any }) => {

  const [stepValue, setStepValue] = useState(0);
  const handleNext = () => {
    if (stepValue < GuideModalData.length - 1) setStepValue(stepValue + 1);
    if (stepValue == GuideModalData.length -1){
        onClose()
    }
  };

  const handlePrev = () => {
    if (stepValue > 0) setStepValue(stepValue - 1);
  };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[1001]" onClose={() => { }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50 " />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className='bg-white rounded-xl overflow-hidden'>

                              <div
                                    key={stepValue}
                                    className="md:w-[560px] w-[360px] bg-white flex flex-col rounded-lg gap-[10px] transition-opacity duration-300 ease-in-out opacity-100"
                                    style={{ animation: 'fadeIn .5s ease-in-out' }}
                                > 
                                <div className='bg-[#F1EFFF] relative sm:h-[320px] h-[220px] overflow-hidden'>
                                    <img className={'absolute'} style={{bottom: `-${GuideModalData[stepValue].imgMargin}px`}} src={GuideModalData[stepValue].image} alt='User' />
                                    {stepValue === 0 &&
                                        <img className={'absolute md:w-8 w-5 md:bottom-[24px] md:left-[190px] bottom-[6px] left-[125px]'}  src={User11} alt='User' />                                   
                                    }
                                    {stepValue === 2 &&
                                        <img className={'absolute md:w-[120px] w-[76px]  md:bottom-[120px] left-[225px] bottom-[62px] md:left-[350px]'}  src={User31} alt='User' />                                   
                                    }
                                    <XMarkIcon className="h-8 w-8 absolute top-5 right-5 text-[#1B2124] cursor-pointer" 
                                    onClick={()=>onClose() } />

                                    </div>
                                    <div>
                                <div className="flex flex-col gap-1 py-4 px-6">
                                    <Typography color="#1B2124" variant='heading4' weight='semi-bold'>
                                        {GuideModalData[stepValue].heading} 
                                    </Typography>
                                    <Typography color="#3D3D3D" variant="regular" weight="medium">
                                        {GuideModalData[stepValue].subheading} 
                                    </Typography>
                                </div>
                                <div className="flex pt-4  p-6">
                                    <div className=' flex grid-cols-2 gap-3 w-full'>
                                        <div className='w-full'>
                                        {GuideModalData[stepValue].btn1 &&
                                            <Button variant='secondary' size='small' onClick={handlePrev} className='w-full'>
                                                {GuideModalData[stepValue].btn1}
                                            </Button>
                                        }
                                        </div>
                                        <div className='w-full'>
                                        <Button variant='primary' size='small' onClick={handleNext} className='w-full' >
                                                {GuideModalData[stepValue].btn2}
                                        </Button>
                                        </div>
                                    </div>
                                </div>
                                    </div>
                                </div>
                                <style>{`
                                    @keyframes fadeIn {
                                    from { opacity: 0 }
                                    to { opacity: 1 }
                                    }
                                `}</style>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
                
            </Dialog>
        </Transition >)
}
export default GuideModal
